__turbopack_context__.v({
  "back-button": "header-module-scss-module__F23zsW__back-button",
  "header": "header-module-scss-module__F23zsW__header",
  "placeholder": "header-module-scss-module__F23zsW__placeholder",
  "progress-bar": "header-module-scss-module__F23zsW__progress-bar",
  "progress-bar-fill": "header-module-scss-module__F23zsW__progress-bar-fill",
  "text": "header-module-scss-module__F23zsW__text",
});
